module.exports = __webpack_public_path__ + "img/that-picture-3.476ee142.png";